<template>
  <div>

<div v-if="user.username!='Guest'">

    <v-radio-group :disabled="loadingJourney.status" class="switch-field1"  v-model="isCreatedOrviewJourneys" @change="setIsCreatedOrviewJourneys()" row background-color="white"
      active-class="active1">
      <v-radio id="radio-two" name="switch-one" :label="$t('createdJourneys')" :value="0"></v-radio>
      <v-radio id="radio-one" name="switch-one" :label="$t('viewJourneys')" :value="1"></v-radio>
    </v-radio-group>

    <v-radio-group :disabled="loadingJourney.status" v-if="isCreatedOrviewJourneys" @change="setIsAllOrNearmeJourneys()" class="switch-field2" v-model="isAllOrNearmeJourneys" row
      active-class="active2">
      <v-radio id="radio-two" name="all" :label="$t('allPublicJourneys')" :value="0" ></v-radio>
      <v-radio id="radio-one" name="nearMe" :label="$t('nearMe')" :value="1" >
      </v-radio>
    </v-radio-group>

    <v-radio-group :disabled="loadingJourney.status" v-else class="switch-field3" v-model="isSavedOrPublishedJourneys" @change="setisSavedOrPublishedJourneys()" row active-class="active3">
      <v-radio id="radio-five" name="createdJourneys" :label="$t('saved')" :value="0" >
      </v-radio>
      <v-radio id="radio-six" name="viewJourneys" :label="$t('published')" :value="1">
      </v-radio>
    </v-radio-group>
</div>
<div v-else>
<div class="mx-2 mt-2 mb-2">{{$t('viewJourneys')}}</div>
    <v-radio-group :disabled="loadingJourney.status" v-if="isCreatedOrviewJourneys"  class="switch-field2" v-model="isAllOrNearmeJourneys" @change="setIsAllOrNearmeJourneys()" row
      active-class="active2">
      <v-radio id="radio-two" name="all" :label="$t('allPublicJourneys')" :value="0" ></v-radio>
      <v-radio id="radio-one" name="nearMe" :label="$t('nearMeJourneys')" :value="1" >
      </v-radio>
    </v-radio-group>
</div>

    <v-row class="text-center">
      <v-col cols="12" class="pb-0 mt-0 mb-0 pt-0 pb-0">
        <v-btn :disabled="loadingJourney.status" v-if="$route.name=='home'" class="px-0 text-uppercase" text big
          @click="gotopage('/map')">
          <i class=" mdi mdi-map-marker"></i> <span style="text-transform: initial!important;">{{ $t("viewOnMap") }}</span>
        </v-btn>
        <v-btn :disabled="loadingJourney.status" v-if="$route.name=='map'" class="px-0 mt-2 mb-2" text big
          @click="gotopage('/home')">
          <i class=" mdi mdi-view-list"></i><span style="text-transform: initial!important;"> {{$t('backToListView')}}</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>


</template>

<script>
//this page is displayed when an error occurs
import {
  mapState
} from 'vuex';
export default {
  name: 'homeToggleFiltersJourney',
  components: {},
  data: () => ({
    getUserCoordinates: null,

    apiUrl: process.env.VUE_APP_ROOT_API,

    //first tab show when logged user not Guest
    isCreatedOrviewJourneys: 0,
    //second tab when first tab=1
    isAllOrNearmeJourneys: 0,
    //third tab when first tab=0
    isSavedOrPublishedJourneys: 0,

    // filtered Journeys
    filteredMyJourneysSavedList: [],
    filteredMyJourneysPublishedList: [],
    filteredAllJourneysPublic: [],
    filteredJourneysListNearMe: [],

    //the Journeys from api without filter
    myJourneysSavedList: [],
    myJourneysPublishedList: [],
    allJourneysPublic: [],
    JourneyslistNearMe: [],

    listOfFilterTag: [],
    locationslist: [],

    textSearchJourneyTitle: "",
    changeText: "",

  }),
  computed: {
    isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    },
    loadingJourney: function () {
      return this.$store.getters.getLoadingJourney;
    },
    ...mapState(['user'])
  },
  async mounted() {

    this.$getLocation()
      .then(response => {
        this.getUserCoordinates = response
      });
/*
              this.$store.dispatch("setSnackbar", {
              color: 'green',
              text: 'coordinates retrive successfully',
              active: true
            })
              this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: 'coordinates retrive successfully',
              active: true
            })
*/

    if (this.$store.getters.getIsCreatedOrviewJourneys) {
      this.isCreatedOrviewJourneys = this.$store.getters.getIsCreatedOrviewJourneys
    }
    this.isAllOrNearmeJourneys = this.$store.getters.getIsAllOrNearmeJourneys
    this.isSavedOrPublishedJourneys = this.$store.getters.getIsSavedOrPublishedJourneys

    if (this.user.username == 'Guest') {
      this.$store.dispatch('setIsCreatedOrviewJourneys', 1)
      this.$store.dispatch('setIsAllOrNearmeJourneys', 0)
    }

    //clear temp information story - used for create or edit
    this.$store.dispatch("clearNewStory")
    this.$indexdb.mediaFiles.clear()
    //retrive Journeys from DB
    await this.getAllJourneysPublic()
    if (this.user.username != 'Guest') {
      await this.getUserJourneysDraft()
      await this.getUserJourneysPublic()
    }
    await this.getJourneysNearMe()

    this.dispatchAllFilteredJourneys()
    this.$store.dispatch('setLoadingJourney', {
      status: false,
      text: ''
    })

    if (this.$store.getters.searchBarTextValueJourney != null || this.$store.getters.searchBarTextValueJourney != "") {
      this.$store.dispatch('setLoading', true)
      await this.filterAllJourneysPublic()
      if (this.user.username != 'Guest') {
        await this.filterMyJourneysSavedList()
        await this.filterMyJourneysPublishedList()
      }
      await this.filterJourneysListNearMe()

      this.dispatchAllFilteredJourneys()

      this.$store.dispatch('setLoadingJourney', {
        status: false,
        text: ''
      })

    } else {
      this.$store.dispatch('setLoading', true)
      this.filteredMyJourneysSavedList = this.myJourneysSavedList
      this.filteredMyJourneysPublishedList = this.myJourneysPublishedList
      this.filteredAllJourneysPublic = this.allJourneysPublic
      this.filteredJourneysListNearMe = this.JourneyslistNearMe

      this.dispatchAllFilteredJourneys()
      this.$store.dispatch('setLoadingJourney', {
        status: false,
        text: ''
      })
    }
  },


  methods: {
    dispatchAllFilteredJourneys: function () {
      this.$store.dispatch('setCurrentallPublicJourneys', this.filteredAllJourneysPublic)
      this.$store.dispatch('setCurrentAllPublicNearMeJourneys', this.filteredJourneysListNearMe)
      this.$store.dispatch('setCurrentUserJourneysDraft', this.filteredMyJourneysSavedList)
      this.$store.dispatch('setCurrentUserJourneysPublished', this.filteredMyJourneysPublishedList)
    },
    // save the current btn selection in store
    setIsCreatedOrviewJourneys: function () {
      this.$store.dispatch('setIsCreatedOrviewJourneys', this.isCreatedOrviewJourneys)
    },
    // save the current btn selection in store
    setIsAllOrNearmeJourneys: function () {
      this.$store.dispatch('setIsAllOrNearmeJourneys', this.isAllOrNearmeJourneys)
    },
    // save the current btn selection in store
    setisSavedOrPublishedJourneys: function () {
      this.$store.dispatch('setIsSavedOrPublishedJourneys', this.isSavedOrPublishedJourneys)
    },
    //change the page
    gotopage: function (page) {
      this.$router.push(page)
    },

    filterMyJourneysSavedList() {
      try {
        if (this.textSearchJourneyTitle != null || this.textSearchJourneyTitle != "") {
          this.filteredMyJourneysSavedList = []
          this.filteredMyJourneysSavedList = this.myJourneysSavedList.filter(function (item) {
            if (item.journeyTitle.toLowerCase().includes(this.textSearchJourneyTitle.toLowerCase())) {
              return true
            }
          }.bind(this))
        } else {
          this.filteredMyJourneysSavedList = this.myJourneysSavedList
        }
      } catch (error) {
        console.log(error);
      }
    },

    filterMyJourneysPublishedList() {
      try {
        if (this.textSearchJourneyTitle != null || this.textSearchJourneyTitle != "") {
          this.filteredMyJourneysPublishedList = []
          this.filteredMyJourneysPublishedList = this.myJourneysPublishedList.filter(function (item) {
            if (item.journeyTitle.toLowerCase().includes(this.textSearchJourneyTitle.toLowerCase())) {
              return true
            }
          }.bind(this))
        } else {
          this.filteredMyJourneysPublishedList = this.myJourneysPublishedList
        }
      } catch (error) {
        console.log(error);
      }
    },

    filterAllJourneysPublic() {
      try {
        if (this.textSearchJourneyTitle != null || this.textSearchJourneyTitle != "") {
          this.filteredAllJourneysPublic = []
          this.filteredAllJourneysPublic = this.allJourneysPublic.filter(function (item) {
            if (this.textSearchJourneyTitle != null && this.listOfFilterTag.length == 0) {
              if (item.journeyTitle.toLowerCase().includes(this.textSearchJourneyTitle.toLowerCase())) {
                return true
              }
            } else if ((this.textSearchJourneyTitle == "" || this.textSearchJourneyTitle == null) && this.listOfFilterTag.length > 0) {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag)) {
                  return true
                }
              }
            } else {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag) && item.journeyTitle.toLowerCase().includes(this.textSearchJourneyTitle.toLowerCase())) {
                  return true
                }
              }
            }
          }.bind(this))
        } else {
          this.filteredAllJourneysPublic = this.allJourneysPublic
        }
      } catch (error) {
        console.log(error);
      }
    },
    //2
    filterJourneysListNearMe() {
      try {
        if (this.textSearchJourneyTitle != null || this.textSearchJourneyTitle != "") {
          this.filteredJourneysListNearMe = []
          this.filteredJourneysListNearMe = this.JourneyslistNearMe.filter(function (item) {
            if (this.textSearchJourneyTitle != null) {
              if (item.journeyTitle.toLowerCase().includes(this.textSearchJourneyTitle.toLowerCase())) {
                return true
              }
            }
          }.bind(this))
        } else {
          this.filteredJourneysListNearMe = this.JourneyslistNearMe
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getAllJourneysPublic() {
      try {

        let completeurl = this.apiUrl + '/getAllPublicJourney?content=true&short=100'
        let tempJourneyslist
        tempJourneyslist = await this.getaxiosResponse(completeurl)
        this.allJourneysPublic = tempJourneyslist.data

      } catch (error) {
        if (error.response.status == 401) {
          this.allJourneysPublic = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })

        } else if (error.response.status == 401) {
          this.allJourneysPublic = []

          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(() => this.gotopage('/splashScreen'))
        } else {
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }
      }
    },
    async getUserJourneysPublic() {
      try {
        let completeurl = this.apiUrl + '/getUserPublicJourney?content=true&short=100'
        let tempUserJourneysPublic
        tempUserJourneysPublic = await this.getaxiosResponse(completeurl)
        this.myJourneysPublishedList = tempUserJourneysPublic.data
      } catch (error) {
        this.myJourneysPublishedList = []
        if (error.response.status == 401) {
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })

        } else if (error.response.status == 401) {
          this.myJourneysPublishedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(() => this.gotopage('/splashScreen'))
        } else {
          this.myJourneysPublishedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }

      }
    },
    async getUserJourneysDraft() {
      try {

        let completeurl = this.apiUrl + '/getUserDraftJourney?content=true&short=100'
        let tempGetUserJourneysDraft
        tempGetUserJourneysDraft = await this.getaxiosResponse(completeurl)
        this.myJourneysSavedList = tempGetUserJourneysDraft.data
      } catch (error) {
        if (error.response.status == 401) {
          this.myJourneysSavedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })

        } else if (error.response.status == 401) {
          this.myJourneysSavedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(() => this.gotopage('/splashScreen'))
        } else {
          this.myJourneysSavedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }

      }
    },
    // retrive all the Journeys Near the user position

    async getJourneysNearMe() {
      try {
        let completeurl
        if (this.getUserCoordinates.lat != null && this.getUserCoordinates.lng != null) {
          completeurl = this.apiUrl + '/getJourneyNearMe?latitude=' + this.getUserCoordinates.lat + '&longitude=' + this.getUserCoordinates.lng + '&meters=50000&max_num=20'
        } else {
          this.$store.dispatch("setSnackbar", {
            color: 'error',
            text: this.$i18n.t('noCoordinates'),
            active: true
          })
          completeurl = this.apiUrl + '/getJourneyNearMe?latitude=' + this.$store.getters.getUser.latitude + '&longitude=' + this.$store.getters.getUser.longitude + '&meters=50000&limit=20'
        }

        let tempJourneysNearMeList
        tempJourneysNearMeList = await this.getaxiosResponse(completeurl)
        this.JourneyslistNearMe = tempJourneysNearMeList.data
        this.JourneyslistNearMe
        //error in KG latitude and longitude are reversed
        /*this.JourneyslistNearMe = this.JourneyslistNearMe.map(function (row) {
          return {
            id: row.id,
            title: row.journeyTitle,
            shortDescription: row.shortDescription,
            latitude: row.latitude,
            longitude: row.longitude,
            cover_image: row.cover_image,
            user: row.user,
            created_at: row.created_at
          }
        })*/
      } catch (error) {
        if (error.response.status == 400) {
          this.JourneyslistNearMe = []

          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        } else {
          this.JourneyslistNearMe = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: this.$t("serverError") + error.response.data,
            active: true
          })
        }
      }
    },
  },
  watch: {
    '$store.state.isStoryEditediNeedToReloadJourneys': function () {
      this.getAllJourneysPublic()
      this.getUserJourneysDraft()
      this.getUserJourneysPublic()
      this.getJourneysNearMe()

      this.filterAllJourneysPublic()
      this.filterMyJourneysSavedList()
      this.filterMyJourneysPublishedList()
      this.filterJourneysListNearMe()
      this.$store.dispatch('setisStoryEditediNeedToReloadJourneys', true)

      this.dispatchAllFilteredJourneys()
    },
    '$store.state.searchBarTextValueJourney': function () {
      this.textSearchJourneyTitle = this.$store.getters.getSearchBarTextValueJourney
      this.$store.dispatch('setLoading', true)

      this.filterAllJourneysPublic()
      this.filterMyJourneysSavedList()
      this.filterMyJourneysPublishedList()
      this.filterJourneysListNearMe()

      this.dispatchAllFilteredJourneys()
      this.$store.dispatch('setLoading', false)

    },
    '$store.state.listOfSelectedTag': function () {
      this.listOfFilterTag = this.$store.getters.getListOfSelectedTag
      this.$store.dispatch('setLoading', true)

      this.filterAllJourneysPublic()
      this.filterMyJourneysSavedList()
      this.filterMyJourneysPublishedList()
      this.filterJourneysListNearMe()

      this.dispatchAllFilteredJourneys()
      this.$store.dispatch('setLoading', false)
    }
  }
}
</script>
<style>
.v-input--selection-controls {
    padding-top: 0px !important;
}
.v-input.switch-field2.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div,
.v-input.switch-field3.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div{
  background-color: #e5e5e5;
  border-radius: 99rem;
}

.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
.v-input__slot{
  margin-bottom: 0px;
}
/* v-radio btn 1*/
.theme--light.v-label{
  color: black;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: auto;
    margin-left: auto;
    width: 48%;
    text-align: center;
}
.v-input--radio-group.v-input--radio-group--row .v-radio > .v-label{
  padding: auto auto;
  text-align: center;
}
.switch-field1 .v-radio:not(.active1) label{

    background-color: white!important;
  color:#38737A!important;
  border-radius: 999rem;
}
.active1 {
  background-color: #81B9BF;
  border-radius: 99rem!important;
}
.active2,.active3{
  background-color: #38737A;
  border-radius: 999rem;
}
div.v-radio.theme--light.active3 > label,div.v-radio.theme--light.active2 > label{
    color: white!important;
}
.switch-field1.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;

}
.switch-field2.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.switch-field3.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.v-input.switch-field1.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot.white > div > div.v-radio.theme--light > div{
  display: none;
}
.v-application--is-ltr .v-input--selection-controls__input {
    display: none;
}

/* end v-radio btn */
.v-tab--disabled {
    pointer-events: none;
    opacity: 1;
}
.v-btn--fab.v-size--x-large {
    height: 100px;
    width: 100px;
}
.rounded-circle{
  border-radius: 50%;
  padding: 10%;
}
.rounded-circle span{
white-space: inherit;
}
.w3-badge{
  border-radius: 50%;
    background-color: gray;
    color: #fff;
    display: inline-block;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    text-align: center;
    line-height: 1.5rem;
}
.border-bottom-grey{
  border-bottom: 1px solid gray;
}
.styleimgthumbnails{
max-width: 90%;
}
.ctadashboard{
  text-transform: capitalize;
}
.ctareadMore{
    text-transform: capitalize;
    color:#AAA
}
.styleimgheritageFull{
  width: 40%;
}
.titleHeritrage{
  text-transform: capitalize;
  font-size: 1rem;;
}
.containerimgsingleStory {
  position: relative;
  text-align: center;
}
.image-inner-container {
    position: absolute;
}
.overlay {
    position: absolute;
    text-align: center;
    width: 100%;
}

.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  justify-content: center
}


/*switch btn Create - view*/
.switch-field1{
	display: flex;
	margin-bottom: 0%;
	overflow: hidden;
}

.switch-field1 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}


.switch-field1 label {
  border-radius: 999rem;
  border: 2px solid transparent;
  width: 50%;
	color: rgba(0, 0, 0, 1);
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*margin-right: -1px;*/
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field1 label:hover {
	cursor: pointer;
}

.switch-field1 input:checked + label {

	border: 2px solid black;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field1 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.switch-field1 label:last-of-type {
	border-radius: 0 4px 4px 0;
}

/*switch btn saved  - Published*/

/*switch btn all  - nearMe*/
.switch-field3,.switch-field2 {

	color: rgba(0, 0, 0, 0.6);
	display: flex;

	overflow: hidden;
}

.switch-field3 input,.switch-field2 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field3 label,.switch-field2 label {
  width: 50%;

	/*background-color: #e5e5e5;
	color: rgba(0, 0, 0, 0.6);*/
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field3 label:hover,.switch-field2 label:hover {
	cursor: pointer;
}

.switch-field3 input:checked + label,.switch-field2 input:checked + label {
	background-color: #000;
  color:#FFF;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field3 label:first-of-type,.switch-field2 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.v-radio.theme--light > label{
  margin-left: auto;
  margin-right: auto;
}
.theme--light.v-label{
  color: #38737A;
}
</style>

